<div class="pt-4">
	<div class="container">
        

        <div class="row" style="gap:30px 0">
            <div class="col-12 col-sm-6 col-xl-3" *ngFor="let card of priceCards">
                <tarifs-card [config]="card"></tarifs-card>
            </div>
        </div>

        <div class="d-flex flex-column align-items-start justify-content-start my-4 text-muted">
            <div>{{"(*) Une remise est appliquée aux établissements d’enseignement supérieur publics ou privés, nous contacter." | translate}}</div>
            <div>{{"(**) Prix pour l'Union Européenne et l'espace Shengen. Pour les autres pays, veuillez nous contacter. Utilisable pendant 12 mois. Au bout de la 2ème année en cas de renouvellement, le casque est offert si vous vous abonnez au catalogue au tarif de 3.700 euros HT par an. En cas de non renouvellement, un bon de retour du matériel vous sera adressé." | translate}}</div>
        </div>

        <hr class="my-0">

        <div class="py-5 d-flex gap-3 flex-column align-items-center justify-content-center">
            <h4 class="font-weight-bold m-0"><span class="text-immersive">{{'100+' | translate}}</span>{{'businesses trust us.' | translate}}</h4>
			<div>{{'See if our online campus right for your team with a free access.' | translate}}</div>
			<button class="btn-immersive d-inline-block btn-git" (click)="freeAccess()">{{'Free trial' | translate}}</button>
        </div>

        <hr class="my-0">

        <app-they-trust-us [title]="null"></app-they-trust-us>

	</div>

</div>